import {People} from "@mui/icons-material"
import i18n from 'i18next';

// ==============================|| DASHBOARD MENU ITEMS ||============================== //


const getAmbassadorLevel = () => ({
    id: 'ambassadorLevel',
    type: 'group',
    children: [
        {
            id: 'ambassadorLevel',
            title: i18n.t('sidemenu.ambassadorLevelManagement'),
            type: 'item',
            url: '/ambassadorLevel',
            icon: People,
            breadcrumbs: false,
        },
    ]
});

export default getAmbassadorLevel;